<template>
  <div>
    <div v-if="!show && !props.show">
      <a @click="show = true" class="help">Mostrar ayuda</a>
    </div>
    <div v-if="show || props.show" class="mt-3">
      <div v-show="props.step == 0">
        <div class="mb-5 line-height-3">
          <p>
            <b>Número</b> es lo que normalmente usas como número de territorio.
            Es obligatorio ponerlo.
          </p>

          <p>
            <b>Zona</b> es una letra, puedes usarla si tienes mas de 99
            territorios o si quieres dividir todo el territorio de la
            congregación en varias partes. Los territorios entonces serian por
            ejemplo: N1, N2, S1, S2, etc. Es opcional.
          </p>
          <p>
            <b>Color para el territorio</b> es el color que se usara para dibujar el territorio en el mapa. Usar diferentes colores para cada territorio. 
          </p>
          <p>
            <b>Grupo</b> es el numero de grupo de congregación que atiende
            normalmente este territorio. Es opcional.
          </p>
          <p>
            Los grupos se configuran en la página de <b>Configuración</b> del
            menu a la izquierda.
          </p>
          <p>
            También puedes escribir un nombre de <b>Referencia</b> como "Barrio
            12 de Enero" y <b>Notas</b> como "Zona peligrosa". Son opcionales.
          </p>
          <p>
            <b>Tipo</b> es el tipo de territorio, puede ser "manzanas" o "rutas".
            Si es "rutas" no se podran marcar manzanas en el mapa. Eligiras rutas creadas en la pagina de <b>Rutas</b>.
          </p>
        </div>
      </div>
      <div v-show="props.step == 1">
        <div class="mb-5 line-height-3">
          <p>
            Tienes que <b>tocar sobre el mapa</b> en cada vertice del
            territorio a dibujar. Al tocar veras
            que empieza a dibujarse una linea, <b>continua</b> hasta que los
            limites del territorio esten bien
            claros.
          </p>

          <p>
            Si te equivocas a quieres volver a marcar los limites solo presiona
            el boton "Limpiar Mapa".
          </p>
          <p>Si ya concluiste de marcar los limites solo presiona X.</p>
        </div>
      </div>
      <div v-show="props.step == 2">
          <p>
            Tienes que <b>tocar sobre el mapa</b> en el centro del
            territorio. Al tocar aparece el nombre del territorio, esto se usara como referecia de geolocalizacion del territorio.
          </p>
          <p>
            Luego de establecer el centro tienes que <b>tocar sobre el mapa</b> en cada lugar donde hay una manzana (o
            porcion en caso de no contener manzanas completas) del territorio a asignar para predicar. Veras que al hacer click van
            apareciendo numeros.
          </p>
          <p>
            Si te equivocas a quieres volver a enumerar solo presiona el boton
            "Limpiar Mapa".
          </p>
          <p>Si ya concluiste de enumerar solo presiona X.</p>
          <p class="text-xs">
            Nota: Esto se utilizara para que te digan que manzanas del
            territorio se predicaron, por lo tanto, no deberias enumerar
            espacios verdes o lugares donde no hay personas a las que predicar.
          </p>
      </div>
      <div v-show="props.step == 3">
        <div class="mb-5 line-height-3">
          <p>
            Tienes que <b>tocar sobre el mapa</b> en cada punto de
            encuentro del territorio. Al tocar posiblemente aparezca la dirección si esta disponible.
          </p>
          <p>
            Si te equivocas a quieres volver a crearlos solo presiona el boton
            "Limpiar Mapa".
          </p>
          <p>Si ya concluiste de enumerar solo presiona X.</p>
        </div>
      </div>
    </div>
    <div v-if="show">
      <a @click="show = false" class="help">Ocultar ayuda</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  step: {
    type: Number,
    default: 0,
  },
  show: {
    type: Boolean,
    default: false,
  },
});
const show = ref(false);
</script>

<style scoped>
.help {
  cursor: pointer;
  color: var(--accent);
}
p {
  margin: 1rem 0 0rem 0;
}
</style>
